<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                chemicalForm: () => import('../forms/ChemicalForm'),
                fileForm: () => import('../forms/FileForm'),
                memberForm: () => import('../forms/MemberForm'),
                fields: [
                    { type: 'datetime', text: 'On', value: 'on', rules: [v => !!v || 'On is required'], isRequired: true },
                    { type: 'autocomplete', text: 'Member', value: 'memberId', rules: [v => !!v || 'Member is required'], isRequired: true, form: () => import('./MemberForm'), apiMethod: 'Members', claim: 'Members' },
                    { type: 'autocomplete', text: 'Chemical', value: 'chemicalId', rules: [v => !!v || 'Chemical is required'], isRequired: true, form: () => import('./ChemicalForm'), apiMethod: 'Chemicals', claim: 'Chemicals' },
                    { type: 'text', text: 'Dose Rate', value: 'doseRate', rules: [v => !!v || 'Dose Rate is required', v => !(v && v.length > 50) || 'Dose Rate must be less than 50 characters'], isRequired: true, maxLength: 50 },
                    { type: 'number', text: 'Withholding Period In Days', value: 'withholdingPeriodInDays', rules: [v => (v !== null && v !== '') || 'Withholding Period In Days is required'], isRequired: true },
                    { type: 'file', text: 'Prescription File', value: 'prescriptionFileId', rules: [], form: () => import('./FileForm'), apiMethod: 'Files' },
                    { type: 'file', text: 'Invoice File', value: 'invoiceFileId', rules: [], form: () => import('./FileForm'), apiMethod: 'Files' },
                ],
                apiMethod: 'ChemicalPurchases',
                formTitle: 'Chemical Purchase',
            }
        },
    };
</script>
